import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { CheckCircle } from "@material-ui/icons";

import { images } from "../utils/images";

const urlSolo = (
  process.env.NODE_ENV === "production" ? window.SOLO.env : process.env
).REACT_APP_DASHBOARD;

function FirstScreen(props) {
  const { classes, t, i18n, account } = props;

  useEffect(() => {
    if (account.account !== null) {
      props.history.push("/id/settings");
    }
  }, [account]);

  // ComponentDidMount
  useEffect(() => {
    document.body.style.background = "#262626";

    return () => {
      document.body.style.background = "#262626";
    };
  }, []);

  return (
    <div className={classes.firstScreen}>
      <div className={classes.soloLogo}>
        <img
          src={images.logos.sologenicWhiteLogo}
          onClick={() => (window.location.href = urlSolo)}
        />
      </div>
      <h1>{t("welcomeToSoloPlat")}</h1>

      <div className="container">
        <div className="containerLeft">
          <div className="icons">
            <img src={images.icons.withAccountSolo} />
          </div>
          <h2>{t("alreadyHaveAccount")}</h2>
          <button onClick={() => props.history.push("/id/login")}>
            {t("signIn")}
          </button>
          <p>{t("_soloIs")}</p>
        </div>
        <div className="containerDivider"></div>
        <div className="containerRight">
          <div className="icons">
            <img src={images.icons.withoutAccountSolo} />
          </div>
          <h2>{t("withoutAccount")}</h2>
          <button onClick={() => props.history.push("/id/signup")}>
            {t("signUp")}
          </button>
          <p>{t("signUpCopyS")}</p>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    account: state.account,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

const styles = function (theme) {
  return {
    soloLogo: {
      marginBottom: 80,
      width: "100%",
      height: "auto",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",

      position: "relative",
      "& img": {
        width: 180,
        height: "auto",
      },
    },
    firstScreen: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      marginLeft: "auto",
      marginRight: "auto",
      marginBottom: 24,
      paddingTop: 80,

      "& h1": {
        fontSize: 24,
        color: theme.colors.text.textOnRed,
        marginTop: 32,
        textAlign: "center",
      },
      "& .container": {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0 80px",
        background: theme.colors.background.fore,
        borderRadius: 2,
        boxShadow: theme.defaults.shadow,
        width: "90%",
        maxWidth: 890,
        height: 430,
        marginTop: 24,
        [theme.breakpoints.down(850)]: {
          padding: "0 40px",
        },
        [theme.breakpoints.down(700)]: {
          flexDirection: "column",
          height: "auto",
          padding: 24,
        },
        "& .containerLeft, & .containerRight": {
          width: "45%",
          height: "50%",
          justifyContent: "flex-start",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          "& .icons": {
            "& img": {
              width: 56,
              height: "auto",
            },
          },
          "& h2": {
            fontSize: 18,
            margin: "16px 0",
            textAlign: "center",
            [theme.breakpoints.down(850)]: {
              fontSize: 16,
            },
          },
          "& button": theme.defaults.roundBtn,
          "& p": {
            marginTop: 32,
            color: theme.colors.text.secondary,
            lineHeight: "21px",
            // fontFamily: "Titillium Web",
            fontSize: 14,
          },
          [theme.breakpoints.down(700)]: {
            width: "100%",
          },
        },
        "& .containerLeft": {
          "& h2": {
            color: theme.colors.buttons.firstScreen,
          },
          "& button": {
            background: theme.colors.buttons.firstScreen,
            color: `${theme.colors.misc.black} !important`,
            fontWeight: 700,
          },
          [theme.breakpoints.down(700)]: {
            marginBottom: 40,
          },
        },
        "& .containerRight": {
          "& .icons": {},
          "& h2": {
            color: theme.colors.buttons.sell,
          },
          "& button": {
            background: "transparent",
            borderColor: `${theme.colors.buttons.sell} !important`,
            color: `${theme.colors.buttons.sell} !important`,
            fontWeight: 700,
          },
        },
        "& .containerDivider": {
          width: 1,
          height: "80%",
          background: theme.colors.misc.dividers,
        },
      },
    },
  };
};

export default withRouter(
  withStyles(styles)(
    withTranslation()(connect(mapStateToProps, mapDispatchToProps)(FirstScreen))
  )
);

// return (
//   <div className={classes.container}>
//     <h1>Electron-React Setup</h1>
//     <div className="image-container">
//       <img src="assets/images/small.png" />
//     </div>
//     <h2>{t("start")}</h2>
//     <button onClick={() => props.setNewTheme("darkTheme")}>Dark</button>
//     <button onClick={() => props.setNewTheme("lightTheme")}>Light</button>
//     <button onClick={() => props.setNewTheme("defaultTheme")}>Default</button>
//     <button onClick={() => i18n.changeLanguage("en-US")}>English</button>
//     <button onClick={() => i18n.changeLanguage("es-MX")}>Español</button>
//   </div>
// );
